var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideos = function SvgVideos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C1.44772 4 1 4.44771 1 5V29.4444C1 29.9967 1.44772 30.4444 2 30.4444H34C34.5523 30.4444 35 29.9967 35 29.4444V5C35 4.44772 34.5523 4 34 4H2ZM6.66669 5.88892H2.88892V7.7778H6.66669V5.88892ZM2.88892 26.6666H6.66669V28.5555H2.88892V26.6666ZM13.2778 5.88892H9.5V7.7778H13.2778V5.88892ZM9.5 26.6666H13.2778V28.5555H9.5V26.6666ZM19.8889 5.88892H16.1111V7.7778H19.8889V5.88892ZM16.1111 26.6666H19.8889V28.5555H16.1111V26.6666ZM26.4999 5.88892H22.7222V7.7778H26.4999V5.88892ZM22.7222 26.6666H26.4999V28.5555H22.7222V26.6666ZM33.111 5.88892H29.3333V7.7778H33.111V5.88892ZM29.3333 26.6666H33.111V28.5555H29.3333V26.6666ZM14.2222 13.2401V21.2043C14.2222 21.9634 15.0346 22.4457 15.701 22.0822L23.0016 18.1001C23.6964 17.7211 23.6964 16.7233 23.0016 16.3443L15.701 12.3622C15.0346 11.9987 14.2222 12.481 14.2222 13.2401Z",
    fill: "#0073BF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videos.910f5ff4.svg";
export { ForwardRef as ReactComponent };